module.exports = function(data) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<i class="all-icon fas fa-check-circle"></i>\n';
 if (data.popover) { ;
__p += '\n<i class="fas fa-question-circle pz-popover unidentified-popover" role="button" data-toggle="popover" data-trigger="hover" data-html="true" data-placement="top" data-content="' +
((__t = ( data.popover )) == null ? '' : __t) +
'"></i>\n';
 } ;
__p += '\n<a href=\'#\' data-nodeid="' +
__e( data.id ) +
'">' +
__e( data.overrideDisplayName || data.display_name ) +
'</a>\n';
 if (data.hasChildren) { ;
__p += '\n<div class="children"></div>\n';
 } ;
__p += '\n';
return __p
}